












































































import { Component, Vue } from "vue-property-decorator";
import { getVersionDetails, versionDownload } from "@/req/homes";
@Component({
  components: {},
})
export default class Home extends Vue {
  public activeIndex: any = 1;
  public detailsId: any = "";
  public data: any = [];
  public extractCode: any = "";
  public uncompressCode: any = "";
  public modal = false;
  public created() {
    if (this.$route.query.id) {
      this.detailsId = this.$route.query.id;
    }
    this.getDetailsList();
  }
  public async getDetailsList() {
    const res = await getVersionDetails({
      token: this.$fn.cookies.getToken(),
      id: this.detailsId,
    })
    if (res.code == 200) {
      this.data = res.data;
    }
  }
  public async download(id) {
    const res = await versionDownload({
      token: this.$fn.cookies.getToken(),
      id,
    })
    if (res.code == 200) {
      window.open(res.data, "_blank");
    }
    this.getDetailsList();
  }
  public getExtract(code, uncompressCode) {
    this.extractCode = code;
    this.uncompressCode = uncompressCode;
    this.modal = true;
  }
  public onCopy() {
    this.$Message.success("复制成功");
  }
  public onError() {
    this.$Message.success("复制失败");
  }
}
